<template>
  <div class="input-range">
    <el-input class="input-item" v-model.trim="data[0]" @input="inputValue"><i v-if="symbol" slot="suffix" class="el-input__icon">{{ symbol }}</i></el-input>
    <span class="separator">{{ separator }}</span>
    <el-input class="input-item" v-model.trim="data[1]" @input="inputValue"><i v-if="symbol" slot="suffix" class="el-input__icon">{{ symbol }}</i></el-input>
  </div>
</template>

<script>
export default {
  props: {
    symbol: String,
    value: Array,
    separator: {
      type: String,
      default: '至'
    }
  },
  data() {
    return {
      data: [this.value ? this.value[0] : null, this.value ? this.value[1] : null]
    };
  },
  watch: {
    value(val) {
      this.data = [this.value ? this.value[0] : null, this.value ? this.value[1] : null]
    },
  },
  methods: {
    inputValue() {
      if (this.data[0] || this.data[1]) {
        if (this.data[0]) {
          this.data[0] = this.data[0].replace(/[^\d.]/g, '');
        }
        if (this.data[1]) {
          this.data[1] = this.data[1].replace(/[^\d.]/g, '');
        }
        this.$emit('input', this.data);
      } else {
        this.$emit('input', []);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.input-range {
  display: flex;
  align-items: center;

  .input-item {
    flex-grow: 1;
  }
  .separator {
    padding: 0 2px;
  }
}
</style>
